/**
 * scope Normalizr Schema
 */

import { schema } from 'normalizr';

const scope = new schema.Entity(
    'scopes',
    {},
    {
        idAttribute: value => `${value.model}.${value.operation}`
    }
);

export default scope;
